import { Stack, Typography } from "@mui/material";

// Quién firma una canción o un evento, de cara al difusor.
//
// El backend resuelve la identidad (utils/identidadArtista): en un perfil
// individual es el perfil; en un sello, manager o label es el ARTISTA del
// roster, y el sello aparece abajo como "vía Mi Sello". Acá solo se muestra.
//
// `fallback` mantiene funcionando lo viejo: los envíos anteriores a la
// atribución llegan sin el campo `artista`, y ahí se usa el nombre del perfil
// como siempre.
export default function NombreArtista({
  artista,
  fallback,
  sufijo,
  variant = "h6",
  ...props
}) {
  const nombre = artista?.nombre || fallback;
  if (!nombre && !sufijo) return null;

  return (
    <Stack spacing={0} {...props}>
      <Typography variant={variant}>
        {nombre}
        {sufijo ? ` - "${sufijo}"` : ""}
      </Typography>
      {artista?.via && (
        <Typography variant="caption" color="text.secondary">
          vía {artista.via}
        </Typography>
      )}
    </Stack>
  );
}
